<h1 mat-dialog-title class="dialog-header">{{ "DatabaseBackup" | translate }}</h1>

<mat-dialog-content class="mat-typography">
  <mat-tab-group [(selectedIndex)]="activeTabIndex">

    <mat-tab [label]="'Backup' | translate">
      <div class="mt-4 mb-2">
        <p class="mb-4">{{ "BackupDescription" | translate }}</p>
        <button mat-flat-button color="primary" (click)="backup()">
          <mat-icon>download</mat-icon>
          {{ "CreateBackup" | translate }}
        </button>
      </div>
    </mat-tab>

    <mat-tab [label]="'Restore' | translate">
      <div class="mt-4 mb-2">
        <p class="mb-4">{{ "RestoreDescription" | translate }}</p>

        <div class="mb-4">
          <label class="block mb-2">{{ "SelectDomains" | translate }}</label>
          <div class="flex flex-col gap-1">
            <mat-checkbox [(ngModel)]="selectedDomains.users">{{ "DomainUsers" | translate }}</mat-checkbox>
            <mat-checkbox [(ngModel)]="selectedDomains.tenants">{{ "DomainTenants" | translate }}</mat-checkbox>
            <mat-checkbox [(ngModel)]="selectedDomains.licences">{{ "DomainLicences" | translate }}</mat-checkbox>
            <mat-checkbox [(ngModel)]="selectedDomains.types">{{ "DomainTypes" | translate }}</mat-checkbox>
          </div>
        </div>

        <div class="mb-4">
          <label class="block mb-2">{{ "SelectFile" | translate }}</label>
          <input type="file" accept=".sql" (change)="onFileChange($event)" />
        </div>

        <button mat-flat-button color="warn"
          [disabled]="!restoreFile || selectedDomainKeys.length === 0 || restoreLoading"
          (click)="restore()">
          <mat-icon>restore</mat-icon>
          {{ restoreLoading ? ("Restoring" | translate) : ("StartRestore" | translate) }}
        </button>

        @if (restoreResult) {
          <div class="mt-4" [class.text-green-600]="restoreResult.success" [class.text-red-600]="!restoreResult.success">
            @if (restoreResult.success) {
              <mat-icon>check_circle</mat-icon>
              {{ "RestoreSuccess" | translate }}: {{ restoreResult.statements }} {{ "Statements" | translate }}
            } @else {
              <mat-icon>error</mat-icon>
              {{ restoreResult.error }}
            }
          </div>
        }
      </div>
    </mat-tab>

  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ "Close" | translate }}</button>
</mat-dialog-actions>
